<div class="content" role="main">

  <ng-container [ngSwitch]="status">

    <mat-spinner id="spinner" [diameter]="50" *ngSwitchCase="'loading'"></mat-spinner>
  <div class="circleicon"*ngSwitchCase="'success'">
    <mat-icon aria-hidden="false" aria-label="Success"  color="primary" >done</mat-icon>
  </div>

  <div class="circleicon error" *ngSwitchCase="'failure'">
    <mat-icon aria-hidden="false" aria-label="Failure"  color="warn" >error</mat-icon>
  </div>

  </ng-container>

  <!-- Highlight Card -->
    <div class="card highlight-card card-small" style="margin-bottom: 50px">
      {{ statusmessage }}
    </div>

  <p *ngIf="status==='failure'">If you think something is wrong, <a target="_blank" href="https://support.xeotek.com/hc/en-us/requests/new">contact us</a>.</p>

    <h2>Next steps</h2>
    <p style="text-align: center">Once your team is created, you will receive an email with your team ID and a Secret. <br/>
      You need this information to start KaDeck Web as a web service within a container in your infrastructure or locally.</p>
    <app-onboarding></app-onboarding>
</div>
